import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaderDetailData, fetchMainData, fetchQualificationData, fetchSolutionTypeData, urlUpdateHandle } from './redux/actions/micrositeAction';
import Header from './components/commonSection/Header';
import PageNotFound from './components/pages/PageNotFound';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import useMicroSiteEncrypt from './components/CustomHook/useMicroSiteEncrypt';
import { Toaster } from 'react-hot-toast';
import MainPageContainer from './components/pages/MainPageContainer';
import CategoryContainer from './components/pages/category/CategoryContainer';
import Footer from './components/commonSection/Footer';
import { isMobile } from 'react-device-detect';

function App() {
  const theme_colors = useSelector((state) => state.microsite?.theme_colors);
  const siteColors = {
      primary: theme_colors?.primary,  // Blue color
      secondary: theme_colors?.secondary,  // Orange color
      textMuted: "#00000070"  // Semi-transparent black
  };
  const dispatch = useDispatch();
  const { microSiteEncrypt, token, error } = useMicroSiteEncrypt();
  const setUrl = "/website";
  
  const captcha_key =
    window.location.origin.includes("spdevmfp") ||
    window.location.origin.includes("localhost")
      ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
      : window.location.origin.includes("sppreprod") ||
        window.location.origin.includes("sptestmfp") ||
        window.location.origin.includes("salespandauat") ||
        window.location.origin.includes("digipulsesp")
      ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
      : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";
  
  useEffect(() => {
    let payload 
    payload = window?.location?.href?.replace("/website","");    
    dispatch(urlUpdateHandle(payload));
    
    const generateHomeToken = async () => {
      const tokenHome = await microSiteEncrypt();
      if (tokenHome && tokenHome !== "") {
        dispatch(fetchMainData(tokenHome, payload));
      }
    };
    
    const generateQualificationToken = async () => {
      const tokenQ = await microSiteEncrypt();
      if (tokenQ && tokenQ !== "") {
        dispatch(fetchQualificationData(tokenQ));
      }
    };
    
    const generateSolutionTypeToken = async () => {
      const tokenStype = await microSiteEncrypt();
      if (tokenStype && tokenStype !== "") {
        dispatch(fetchSolutionTypeData(tokenStype));
      }
    };
    
    generateHomeToken();
    generateQualificationToken();
    generateSolutionTypeToken();
  }, []);
  
  useEffect(() => {
    
    // if(window.location.origin.includes("sptestmfp.com") || window.location.origin.includes("abcstellarpartner.com")) return;

    if (window.location.origin.includes("localhost")) {
    return;
    }
    
    const script = document.createElement('script');

    script.src = window.location.origin + "/chatbot/js/loadContent.js"; // URL of the script you want to load
    script.async = true; // Load the script asynchronously
    script.onload = () => {
      console.log('Script loaded successfully');
    };
    
    setTimeout(() => {
      document.body.appendChild(script);  
    }, 3000);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
    <div className="App">
      <BrowserRouter basename={setUrl}>
        <GoogleReCaptchaProvider reCaptchaKey={captcha_key}>
        <Toaster position="bottom-center" reverseOrder={false} />
        <Header/>
        <Routes>
          <Route path="/" >
            <Route path='category' index={false} element={<CategoryContainer authToken={"authToken"} pageName="product" subPageName="conatiner"/>} />
            <Route index={true} element={<MainPageContainer authToken={"authToken"} pageName="product" subPageName="conatiner"/>} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        {/* {isMobile ? <Footer colors={siteColors} />:""} */}
        
        </GoogleReCaptchaProvider>
      </BrowserRouter>
      <div id='chatbot' ></div>
    </div>
  );
}

export default App;
